<template>
  <ion-page>
    <!-- <ion-header> -->
    <div class="overlay" v-if="currentTab !== 'match-detail'">
      <ion-toolbar class="sleek-header">
        <ion-buttons slot="start">
          <ion-button fill="clear" @click="openMenu()" class="menu-button">
            <ion-icon :icon="menuSharp" class="menu-icon"></ion-icon>
          </ion-button>
        </ion-buttons>
        <span class="sleek-title">{{ appTitle }}</span>
        <ion-buttons slot="end">
          <ion-button
            fill="clear"
            @click="openFilterSheet()"
            class="filter-button"
          >
            <ion-icon :icon="optionsOutline" class="filter-icon"></ion-icon>
          </ion-button>
        </ion-buttons>
      </ion-toolbar>
      <!-- Sticky Filter Pills -->
      <div class="sticky-filters">
        <!-- Competition Selection Pill -->
        <div class="competition-pill">
          <div class="pill-content" @click="compListOpen = !compListOpen">
            <ion-icon :icon="trophyOutline" class="pill-icon"></ion-icon>
            <span class="pill-text">{{
              getSelectedCompetitionName() || "All Competitions"
            }}</span>
            <ion-icon
              :icon="chevronDownOutline"
              class="pill-chevron"
            ></ion-icon>
          </div>
        </div>

        <!-- Round Pills (Horizontal Scroll) -->
        <div class="rounds-section" v-if="availableRounds.length">
          <div class="rounds-scroll">
            <div
              class="round-pill"
              :class="{ active: round === false }"
              @click="round = false"
            >
              All Rounds
            </div>
            <div
              v-for="roundItem in availableRounds"
              :key="roundItem.round"
              class="round-pill"
              :class="{ active: round === roundItem.round }"
              @click="round = roundItem.round"
            >
              {{ roundItem.format }}
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Enhanced Selection Section -->

    <!-- </ion-header> -->
    <ion-content class="ion-content" v-if="!compListOpen && !loading">
      <div class="mt-20" v-if="currentTab === 'explore'">
        <explore />
      </div>
      <div v-if="currentTab === 'schedule'" class="mt-20">
        <div v-if="filteredMatches.length && displayMatches === true">
          <!-- Desktop Table View -->
          <div class="competition-section-desktop">
            <template
              v-for="{ round, matches, format } in groupedMatches"
              :key="round"
            >
              <div class="matches-table-section">
                <!-- Round Header -->
                <div class="round-header-desktop">
                  <h4 class="round-title">{{ format }}</h4>
                  <div class="round-meta">
                    <span class="match-count"
                      >{{ matches.length }}
                      {{ matches.length === 1 ? "match" : "matches" }}</span
                    >
                  </div>
                </div>

                <!-- Table Header -->
                <div class="matches-table-header">
                  <div class="table-col col-time">Time</div>
                  <div class="table-col col-teams">Teams</div>
                  <div class="table-col col-score">Score</div>
                  <div class="table-col col-status">Status</div>
                  <div class="table-col col-venue">Venue</div>
                </div>

                <!-- Matches Table -->
                <div class="matches-table-body">
                  <match-card-desktop
                    v-for="match in matches"
                    :key="match._id"
                    :match="match"
                  />
                </div>

                <!-- Byes Section -->
                <template v-for="match in matches" :key="`bye-${match._id}`">
                  <div
                    class="byes-section"
                    v-if="
                      match &&
                      match.round.type.toLowerCase() == 'regular' &&
                      getByes(match.round).length &&
                      match.lastMatchOfRound === true
                    "
                  >
                    <div class="byes-header">
                      <h5 class="byes-title">
                        Round {{ match.round.number }} BYES
                      </h5>
                    </div>
                    <div class="byes-grid">
                      <div
                        v-for="({ team }, idx) in getByes(match.round)"
                        :key="idx"
                        class="bye-team"
                      >
                        <TeamLogoOpacity :team="team" />
                        <span class="bye-team-name notranslate">{{
                          get(team, "name", "N/A")
                        }}</span>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
            </template>
          </div>

          <!-- Mobile Card View -->
          <div class="competition-section">
            <template
              v-for="{ round, matches, format } in groupedMatches"
              :key="round"
            >
              <div>
                <ion-text v-if="Number.isInteger(round)">
                  <h4 class="round-text f-bold">{{ format }}</h4>
                </ion-text>
                <ion-text v-else>
                  <h4 class="round-text f-bold">{{ format }}</h4>
                </ion-text>
                <template v-for="match in matches" :key="match._id">
                  <MatchCard
                    :match="match"
                    :competitionId="+get(match, 'competition._id')"
                  />
                </template>
                <template v-for="match in matches" :key="match._id">
                  <ion-card
                    class="bye-card"
                    v-if="
                      match &&
                      (match.round.type.toLowerCase() == 'regular' ||
                        match.round.type.toLowerCase() == 'knockout') &&
                      getByes(match.round).length &&
                      match.lastMatchOfRound === true
                    "
                  >
                    <ion-card-content>
                      <ion-text>
                        <h4 class="round-text f-bold">
                          Round {{ match.round.number }} BYES
                        </h4>
                      </ion-text>
                      <ion-slides pager="true" :options="slideOpts">
                        <ion-slide
                          v-for="({ team }, idx) in getByes(match.round)"
                          :key="idx"
                        >
                          <div class="flex flex-column align-center">
                            <TeamLogoOpacity :team="team" />
                            <div class="team-name light-text text-center mt-10">
                              {{ get(team, "name", "N/A") }}
                            </div>
                          </div>
                        </ion-slide>
                      </ion-slides>
                    </ion-card-content>
                  </ion-card>
                </template>
              </div>
            </template>
          </div>
        </div>
        <div v-else-if="displayMatches === false" class="empty-container">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder text-center">
                Matches Result Not Available to Public
              </h1>
            </ion-text>
          </ion-card>
        </div>
        <div v-else-if="matchesLoaded" class="empty-container">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">{{ competitions.length === 0 ? "No competitions available for this entity." : "No Matches Available" }}</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
      <div
        v-if="currentTab === 'ladder'"
        class="flex flex-column justify-center"
        style="width: 100%"
      >
        <Ladder
          v-if="ladder.competition"
          :key="key"
          :ladder="ladder"
          :selectedPool="selectedPool"
        />
        <div v-else-if="displayLadders === false" class="empty-container">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">Ladders Not Available to Public</h1>
            </ion-text>
          </ion-card>
        </div>
        <div v-else class="empty-container">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder">No Ladder Available</h1>
            </ion-text>
          </ion-card>
        </div>
      </div>
      <div
        v-if="currentTab === 'leaderboard'"
        class="flex flex-column justify-center"
        style="width: 100%"
      >
        <ion-item class="mt-20 pl-10" lines="none">
          <ion-label>Stat</ion-label>
          <ion-select v-model="eventType" interface="popover">
            <ion-select-option
              v-for="type in scoringTypes"
              :key="type.type"
              :value="type.type"
              >{{ `${type.name}s` }}</ion-select-option
            >
          </ion-select>
        </ion-item>

        <div v-if="!loading && !eventType" class="empty-container">
          <ion-card>
            <ion-text color="secondary">
              <h1 class="empty-placeholder text-center">Select a stat type to load the leaderboard</h1>
            </ion-text>
          </ion-card>
        </div>
        <template v-else>
          <ion-text v-if="eventLadder.competition">
            <h4 class="round-text f-bold notranslate">{{ eventLadder.competition.name }}</h4>
          </ion-text>
          <ScoringLadder
            :key="key"
            :eventLadder="eventLadder"
            :eventType="find(scoringTypes, (type) => type.type === +eventType)"
            :loading="loading || !eventLadderLoaded"
          />
        </template>
      </div>
    </ion-content>

    <!-- Competitions Dropdown Modal -->
    <div v-if="compListOpen && !loading" class="competitions-dropdown">
      <!-- Search Input -->
      <div class="search-container">
        <div class="search-input-wrapper">
          <ion-icon :icon="searchOutline" class="search-icon"></ion-icon>
          <input
            v-model="competitionSearchQuery"
            type="text"
            placeholder="Search competitions..."
            class="search-input"
            ref="competitionSearchInput"
          />
          <ion-button
            v-if="competitionSearchQuery"
            fill="clear"
            @click="clearSearch"
            class="clear-search-button"
          >
            <ion-icon :icon="closeOutline" class="clear-icon"></ion-icon>
          </ion-button>
        </div>
      </div>

      <div class="competitions-list" ref="competitionsList">
        <div
          v-for="({ _id, name }, index) in filteredCompetitions"
          :key="_id"
          @click="
            selectCompetition(_id);
            compListOpen = false;
          "
          :class="['competition-item', { selected: competitionId === _id }]"
          :style="{
            '--item-index': index,
            'animation-delay': `${index * 0.05}s`,
          }"
          :ref="`competition-${_id}`"
        >
          <div class="item-content">
            <ion-icon :icon="trophyOutline" class="competition-icon"></ion-icon>
            <span class="competition-name notranslate">{{ name }}</span>
            <div class="selection-indicator" v-if="competitionId === _id">
              <ion-icon :icon="checkmarkCircle"></ion-icon>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ion-content v-else-if="loading">
      <LadderSkeleton v-if="currentTab === 'leaderboard'" />
      <Skeleton v-else />
    </ion-content>

    <!-- Filter Sheet -->
    <div
      v-if="filterSheetOpen"
      class="filter-sheet-overlay"
      @click="closeFilterSheet()"
    >
      <div class="filter-sheet" @click.stop>
        <div class="filter-header">
          <h3 class="filter-title">Filters</h3>
          <ion-button
            fill="clear"
            @click="closeFilterSheet()"
            class="close-button"
          >
            <ion-icon :icon="closeOutline"></ion-icon>
          </ion-button>
        </div>

        <div class="filter-content">
          <!-- Season Filter -->
          <div class="filter-section">
            <div class="filter-label">
              <ion-icon :icon="calendarOutline" class="filter-icon"></ion-icon>
              <span>Season</span>
            </div>
            <ion-select
              v-model="filterSeason"
              interface="popover"
              placeholder="Select Season"
              class="filter-select"
            >
              <ion-select-option
                v-for="season in seasons"
                :key="season._id"
                :value="season._id"
              >
                {{ season._id }}
              </ion-select-option>
            </ion-select>
          </div>

          <!-- Match Status Filter -->
          <div class="filter-section">
            <div class="filter-label">
              <ion-icon :icon="checkmarkCircle" class="filter-icon"></ion-icon>
              <span>Match Status</span>
            </div>
            <div class="status-chips">
              <div
                class="status-chip"
                :class="{ active: selectedStatus === 'all' }"
                @click="selectedStatus = 'all'"
              >
                All Matches
              </div>
              <div
                class="status-chip"
                :class="{ active: selectedStatus === 'pre-game' }"
                @click="selectedStatus = 'pre-game'"
              >
                Upcoming
              </div>
              <div
                class="status-chip"
                :class="{ active: selectedStatus === 'live' }"
                @click="selectedStatus = 'live'"
              >
                Live
              </div>
              <div
                class="status-chip"
                :class="{ active: selectedStatus === 'final' }"
                @click="selectedStatus = 'final'"
              >
                Final
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ion-page>
</template>

<script>
import { menuController } from "@ionic/vue";
import {
  arrowBackOutline,
  arrowForwardOutline,
  calendarOutline,
  caretDownOutline,
  checkmarkCircle,
  chevronDownOutline,
  chevronUpOutline,
  closeOutline,
  ellipsisVertical,
  flagOutline,
  layersOutline,
  listOutline,
  menuSharp,
  optionsOutline,
  peopleOutline,
  personCircle,
  podiumOutline,
  searchOutline,
  trophyOutline,
} from "ionicons/icons";
import _ from "lodash";
import moment from "moment-timezone";
import { mapGetters } from "vuex";
import { utcToZonedTime, zonedTimeToUtc } from 'date-fns-tz';
import Ladder from "../../components/Ladder";
import LadderSkeleton from "../../components/LadderSkeleton";
import MatchCard from "../../components/MatchCard.vue";
import MatchCardDesktop from "../../components/MatchCardDesktop.vue";
import ScoringLadder from "../../components/ScoringLadder";
import Skeleton from "../../components/Skeleton";
import Explore from "../Explore.vue";
import TeamLogoOpacity from "./base/team-logo-opacity.vue";
import TeamLogo from "./base/team-logo.vue";

export default {
  components: {
    TeamLogo,
    TeamLogoOpacity,
    MatchCard,
    MatchCardDesktop,
    Ladder,
    LadderSkeleton,
    ScoringLadder,
    Skeleton,
    Explore,
  },
  props: {
    entityLevel: String,
    entityName: String,
  },
  setup() {
    return {
      flagOutline,
      podiumOutline,
      arrowBackOutline,
      arrowForwardOutline,
      caretDownOutline,
      menuSharp,
      calendarOutline,
      trophyOutline,
      listOutline,
      peopleOutline,
      layersOutline,
      closeOutline,
      checkmarkCircle,
      chevronUpOutline,
      chevronDownOutline,
      optionsOutline,
      searchOutline,
    };
  },
  data() {
    const { filter } = this.$store.state.matches;
    // Use stored season from UI store, or fall back to current year
    let season = this.$store.getters['ui/season'] || new Date().getFullYear();
    // if (+process.env.VUE_APP_NATIONAL_ID === 7) {
    //   season = 2024;
    // }
    return {
      $background: null,
      sortBy: _.sortBy,
      slideOpts: {
        initialSlide: 1,
        speed: 400,
        navigation: false,
        pagination: false,
        centerInsufficientSlides: true,
        // slidesPerView: 4,
        breakpoints: {
          // when window width is >= 320px
          320: {
            slidesPerView: 3,
            spaceBetween: 20,
          },
          // when window width is >= 480px
          480: {
            slidesPerView: 4,
            spaceBetween: 30,
          },
          // when window width is >= 640px
          640: {
            slidesPerView: 5,
            spaceBetween: 40,
          },
        },
      },
      compListOpen: false,
      dateFilter: false,
      upperCase: _.upperCase,
      get: _.get,
      find: _.find,
      ellipsisVertical,
      personCircle,
      competitions: [],
      filterSeason: season,
      competitionId: null,
      competition: {},
      round: filter.round,
      team: filter.team,
      matches: [],
      byes: [],
      ladder: {},
      eventLadder: [],
      eventLadderLoaded: false,
      eventTypesCache: {},
      leaderboardCache: {},
      leaderboardRequests: {},
      leaderboardRequestKey: null,
      matchesLoaded: false,
      filter,
      key: 0,
      loading: true,
      segment: "matches",
      ladderSegment: "ladderBoard",
      eventType: null,
      displayMatches: true,
      displayLadders: true,
      timers: [],
      pusher: {},
      scoringEventTypes: [],
      isEmpty: _.isEmpty,
      selectedPool: null,
      currentTab: "",
      gameTypes: [
        { type: "all", name: "All" },
        { type: "teams", name: "Teams" },
        { type: "indv", name: "Individual" },
      ],
      gameType: "all",
      filtersExpanded: false,
      filterSheetOpen: false,
      selectedStatus: "all",
      competitionSearchQuery: "",
    };
  },
  updated() {
    // const uiCompId = this.$store.getters['ui/competitionId'];
    // if (uiCompId) {
    //   this.competitionId = uiCompId;
    // }
    // const uiSeason = this.$store.getters['ui/season'];
    // if (uiSeason) {
    //   this.filterSeason = uiSeason;
    // }
  },
  async beforeMount() {
    console.log("----------- beforeMount ------------");
    try {
      // If there's a forceReload query param, clean it up before proceeding
      if (this.$route.query.forceReload) {
        console.log("Found forceReload query param, cleaning up");
        this.$router
          .replace({
            path: this.$route.path,
            query: {},
          })
          .catch((err) => {
            if (err.name !== "NavigationDuplicated") {
              throw err;
            }
          });
      }

      const path = this.$route.path;
      if (path.includes("/ladders")) {
        this.currentTab = "ladder";
      } else if (path.includes("/leaderboard")) {
        this.currentTab = "leaderboard";
      } else if (path.includes("/schedule")) {
        this.currentTab = "schedule";
      } else {
        this.currentTab = this.$store.getters["matches/currentTab"];
      }

      const compId = this.$store.getters["matches/getCompetitionId"];
      console.log({
        compId,
      });
      // Skip restoring the persisted competitionId on entity-scoped routes; the entity watcher selects the correct one
      if (compId && !(this.entityLevel && this.entityName)) {
        this.competitionId = compId;
      }
      console.log({
        competitionId: this.competitionId,
      });

      if (this.scoringTypes && this.scoringTypes.length > 0) {
        console.log("---- beforeMount: this.scoringTypes ----");
        this.eventType = this.scoringTypes[0].type;
      }
      await this.customArrange();

      // Check for entity mismatch that might need to be addressed
      if (
        window.innerWidth < 768 &&
        this.entity &&
        this.$route.params.entityName &&
        this.entity.name !== this.$route.params.entityName
      ) {
        console.log("Entity mismatch detected during mount, forcing reload");
        this.forceReload();
      }
    } catch (error) {
      console.log(error);
    }
    // loadingController
    //   .create({ message: "Loading competitions..." })
    //   .then(loading => {
    //     loading.present();
    //   });
  },
  mounted() {
    console.log("----------- mounted ------------");
    // Fetch is handled by ionViewWillEnter (fires after mounted on first entry)
    setTimeout(() => {
      this.selectClosestRound();
      this.scrollToMostRecentRound();
    }, 1000);
  },
  async ionViewWillEnter() {
    const path = this.$route.path;
    if (path.includes("/ladders")) {
      this.currentTab = "ladder";
    } else if (path.includes("/leaderboard")) {
      this.currentTab = "leaderboard";
    } else if (path.includes("/schedule")) {
      this.currentTab = "schedule";
    }
    this.loading = true;
    this.eventLadderLoaded = false;
    this.matchesLoaded = false;
    if (this.currentTab === "leaderboard") {
      await this.getEventTypes();
      await this.fetchLeaderboard();
    } else if (this.competitionId) {
      this.fetchCompetitionData(this.competitionId);
    }
  },
  computed: {
    ...mapGetters("national", ["timezone"]),
    scoringTypes() {
      let types = [];
      const competition = _.find(
        this.competitions,
        (c) => c._id === this.competitionId
      );
      const isCustom = _.get(competition, "isCustom", false);
      if (competition) {
        const useCustomScoringEvents = _.get(
          competition,
          "competitionSettings.useCustomScoringEvents",
          undefined
        );
        const nationalScoringEvents = _.get(
          competition,
          "competitionSettings.nationalScoringEvents",
          []
        );
        const scoringEvents = isCustom
          ? _.get(competition, "scoringEvents", [])
          : _.get(competition, "competitionSettings.scoringEvents", []);
        const filteredMatches = _.filter(
          this.$store.state.national.scoringEvents,
          (st) => _.includes(nationalScoringEvents, st.type)
        );
        const scoringResult = useCustomScoringEvents
          ? _.concat(scoringEvents, filteredMatches)
          : scoringEvents;
        if (
          !useCustomScoringEvents ||
          !scoringResult ||
          scoringResult.length < 1
        ) {
          types =
            scoringResult && scoringResult.length
              ? scoringResult
              : this.$store.state.national.scoringEvents;
        }
        console.log({ scoringEvents: scoringResult });
        types = scoringResult;
      }

      console.log({ scoringEvents: this.$store.state.national.scoringEvents });
      types = this.$store.state.national.scoringEvents;
      return types.filter((type) => type.name);
    },
    pools() {
      const { competition } = this;
      return _.get(competition, "pools", []);
    },
    // scoringTypes(){
    //   const types = this.$store.state.national.scoringEvents;
    //   return _.filter(types, (type) => type.visibleInLadders !== false);
    // },
    appTitle() {
      const meta = this.$store.getters["national/getMeta"];
      console.log("meta at scheduler", meta);
      if (meta && meta.name) return meta.name;
      return process.env.VUE_APP_BANNER_TITLE;
    },
    roundSortDirection() {
      const ascendingNationals = [22];
      return _.includes(ascendingNationals, +process.env.VUE_APP_NATIONAL_ID) ? "asc" : "desc";
    },
    seasons() {
      const seasons = this.$store.state.national.seasons;
      return seasons.sort((a, b) => b._id - a._id);
    },
    entity() {
      return this.$store.getters["national/getEntity"];
    },
    rounds() {
      return _.uniq(
        _.map(
          this.matches,
          (match) =>
            _.get(match, "round.displayName") || _.get(match, "round.name")
        )
      );
    },
    teams() {
      return _.uniq(
        [
          _.map(this.matches, "homeTeam.name"),
          _.map(this.matches, "awayTeam.name"),
        ].flat()
      );
    },
    sortedCompetitions() {
      const { competitions, key } = this;
      return _.orderBy(this.competitions, ["order"], ["asc"]);
    },
    filteredCompetitions() {
      if (!this.competitionSearchQuery) {
        return this.sortedCompetitions;
      }
      const query = this.competitionSearchQuery.toLowerCase();
      return this.sortedCompetitions.filter((competition) =>
        competition.name.toLowerCase().includes(query)
      );
    },
    availableDates() {
      // get match.dateTime and group by dates, return array of dates
      const { matches } = this;
      const dates = _.map(matches, (match) => {
        return {
          format: moment(match.dateTime).format("DD MMM").toUpperCase(),
          // return day of week if not today, otherwise return today
          dayOfWeek:
            moment(match.dateTime).format("DD MMM") !==
            moment().format("DD MMM")
              ? moment(match.dateTime).format("ddd").toUpperCase()
              : "Today",
        };
      });
      // filter duplicate formats
      return dates.filter((date, index) => {
        return dates.findIndex((d) => d.format === date.format) === index;
      });
    },
    availableRounds() {
      // get match.round and group by rounds, return array of rounds
      const matches = this.matches;
      matches.forEach((item) => {
        if (item.round.type.toLowerCase() == "regular") {
          item.round.arrange = item.round.number;
        } else if (item.round.type.toLowerCase() == "final") {
          item.round.arrange =
            item.round.displayName ||
            item.round.name ||
            `Final ${item.round.number}`;
        } else if (item.round.type.toLowerCase() == "knockout") {
          item.round.arrange = item.round.number;
        }
      });
      // const nowTime = Date.now();
      // const matchesInThePresentAndFuture = _.orderBy(_.filter(matches, (m) => nowTime <= m.dateTime), 'dateTime', 'asc');
      // const matchesInThePast = _.orderBy(_.filter(matches, (m) => nowTime > m.dateTime), 'dateTime', 'desc');
      // const roundsPresentAndFuture = _.groupBy(matchesInThePresentAndFuture, 'round.arrange');
      // const roundsPast = _.groupBy(matchesInThePast, 'round.arrange');
      // const combinedMatches = [...matchesInThePresentAndFuture, ...matchesInThePast];
      const regularRounds = _.filter(
        matches,
        (m) => m.round.type === "Regular" || m.round?.originalType === "Regular"
      );
      const finalRounds = _.filter(matches, (m) => m.round.type === "Final");
      const knockoutRounds = _.filter(
        matches,
        (m) => m.round.type === "Knockout"
      );
      const mappedRoundNumbers = _.map(regularRounds, "round.number");
      const uniqueRoundNumbers = _.uniq(mappedRoundNumbers);
      const lastRegularRoundNumber = _.max(uniqueRoundNumbers);
      const unnamedFinalRoundNumbers = _.uniq(
        _.filter(finalRounds, (m) => !m.round.displayName && !m.round.name).map(
          (m) => m.round.number
        )
      );
      const singleUnnamedFinalRound = unnamedFinalRoundNumbers.length <= 1;
      regularRounds.forEach((item) => {
        item.round.arrange = item.round.number;
      });
      finalRounds.forEach((item) => {
        item.round.arrange =
          item.round.displayName ||
          item.round.name ||
          `Final ${item.round.number}`;
      });
      knockoutRounds.forEach((item) => {
        item.round.arrange = item.round.number + (lastRegularRoundNumber || 0);
      });
      let orderedRegularRounds = _.orderBy(
        regularRounds,
        "round.number",
        this.roundSortDirection
      );
      let orderedFinalRounds = _.orderBy(
        finalRounds,
        "round.number",
        this.roundSortDirection
      );
      let orderedKnockoutRounds = _.orderBy(
        knockoutRounds,
        "round.number",
        this.roundSortDirection
      );
      if (+process.env.VUE_APP_NATIONAL_ID === 22) {
        orderedRegularRounds = _.orderBy(
          regularRounds,
          ['pool.poolLevel', 'round.number'],
          ['asc', this.roundSortDirection]
        );
        orderedFinalRounds = _.orderBy(
          finalRounds,
          ['pool.poolLevel', 'round.number'],
          ['asc', this.roundSortDirection]
        );
        orderedKnockoutRounds = _.orderBy(
          knockoutRounds,
          ['pool.poolLevel', 'round.number'],
          ['asc', this.roundSortDirection]
        );
      }
      const combinedMatches = this.roundSortDirection === "asc"
        ? [
          ...orderedRegularRounds,
          ...orderedKnockoutRounds,
          ...orderedFinalRounds,
        ]
        : [
          ...orderedFinalRounds,
          ...orderedKnockoutRounds,
          ...orderedRegularRounds,
        ];
      const groupedCombinedMatches = _.groupBy(
        combinedMatches,
        "round.arrange"
      );
      const combinedRounds = _.sortBy(groupedCombinedMatches, (group) =>
        combinedMatches.indexOf(group[0])
      );
      const rounds = Object.keys(combinedRounds).map((key) => {
        const firstMatch = combinedRounds[key][0];
        const roundType = _.get(firstMatch, "round.type", "");
        const roundOriginalType = _.get(firstMatch, "round.originalType", "");
        const roundNumber = _.get(firstMatch, "round.number", "");
        // Build a fallback label based on round type if displayName/name are missing
        const fallbackLabel = roundType === "Regular" || roundOriginalType === "Regular"
          ? (roundNumber === "" ? "Round" : `Round ${roundNumber}`)
          : roundType === "Final"
            ? (singleUnnamedFinalRound ? "Final" : `Final ${roundNumber}`)
            : roundType === "Knockout"
              ? `Knockout ${roundNumber}`
              : `Round ${roundNumber}`;
        return {
          round: _.get(firstMatch, "round.arrange"),
          format:
            _.get(firstMatch, "round.displayName") ||
            _.get(firstMatch, "round.name") ||
            fallbackLabel,
          dateTime: _.get(firstMatch, "dateTime", 0),
        };
      });

      // filter duplicate rounds by arrange value (not format) to preserve distinct rounds
      // that may share the same display name
      return rounds.filter((round, index) => {
        return rounds.findIndex((r) => r.round === round.round) === index;
      });
    },
    filteredMatches() {
      console.log("----------- filteredMatches ------------");
      let matches = Object.assign([], _.cloneDeep(this.matches)).sort(
        (a, b) => {
          return (
            b.round.number - a.round.number ||
            (b.round.type === "Final" ? 1 : -1)
          );
        }
      );

      // Filter by status
      if (this.selectedStatus !== "all") {
        if (this.selectedStatus === "live") {
          matches = matches.filter(
            (match) =>
              match.status === "first-half" ||
              match.status === "second-half" ||
              match.status === "live"
          );
        } else {
          matches = matches.filter(
            (match) => match.status === this.selectedStatus
          );
        }
      }

      if (this.selectedPool) {
        const poolTeamIds = this.selectedPool.teams.map((team) => team._id);
        // matches = matches.filter(match =>
        //   (match.homeTeam && poolTeamIds.includes(match.homeTeam._id)) ||
        //   (match.awayTeam && poolTeamIds.includes(match.awayTeam._id))
        // );
        matches = matches.filter((match) => {
          console.log({
            match,
            matchPool: match.pool,
            selectedPool: this.selectedPool.name,
          });
          return match.pool
            ? match.pool.name === this.selectedPool.name
            : (match.homeTeam && poolTeamIds.includes(match.homeTeam._id)) ||
                (match.awayTeam && poolTeamIds.includes(match.awayTeam._id));
        });
      }

      const regularR = matches.filter((m) => m.round.type === "Regular");
      const finalR = matches.filter((m) => m.round.type === "Final");
      const knockoutR = matches.filter((m) => m.round.type === "Knockout");

      const uniqueRoundNumbers = [
        ...new Set(regularR.map((m) => m.round.number)),
      ];
      const lastRegularRoundNumber = Math.max(...uniqueRoundNumbers, 0);

      const regularRounds = regularR.map((r) =>
        r.round
          ? { ...r, round: { ...r.round, arrange: r.round.number } }
          : { ...r, round: { arrange: r.round.number } }
      );
      const finalRounds = finalR.map((r) =>
        r.round
          ? {
            ...r,
            round: {
              ...r.round,
              arrange:
                  r.round.displayName ||
                  r.round.name ||
                  `Final ${r.round.number}`,
            },
          }
          : {
            ...r,
            round: {
              arrange: `Final ${r.round?.number || "Unknown"}`,
              matches: [],
            },
          }
      );
      const knockoutRounds = knockoutR.map((r) =>
        r.round
          ? {
            ...r,
            round: {
              ...r.round,
              arrange: r.round.number + lastRegularRoundNumber,
            },
          }
          : {
            ...r,
            round: {
              arrange: r.round.number + lastRegularRoundNumber,
              matches: [],
            },
          }
      );

      const allRounds = [...regularRounds, ...finalRounds, ...knockoutRounds];
      const roundFiltered = !this.round
        ? matches
        : allRounds.filter((m) => m.round.arrange === this.round);
      const nextRoundFiltered = !this.round
        ? this.matches
        : this.matches.filter((m) => m.round.number === this.round + 1);
      const isComplete = roundFiltered.every((rnd) => rnd.status === "final");

      const teamFiltered = !this.team
        ? roundFiltered
        : roundFiltered.filter(
          (m) =>
            (m.homeTeam && m.homeTeam.name === this.team) ||
              (m.awayTeam && m.awayTeam.name === this.team)
        );

      const rounds = [...new Set(teamFiltered.map((m) => m.round.number))];
      const lastMatch = rounds
        .map((round) => {
          const roundMatches = teamFiltered.filter(
            (m) => m.round.number === round
          );
          roundMatches[roundMatches.length - 1] = {
            ...roundMatches[roundMatches.length - 1],
            lastMatchOfRound: true,
          };
          return roundMatches;
        })
        .flat();

      const filteredMatches = lastMatch.sort((a, b) => {
        const direction = this.roundSortDirection === "asc" ? 1 : -1;

        return (
          direction *
            (this.getRoundSortOrder(a, lastRegularRoundNumber) -
              this.getRoundSortOrder(b, lastRegularRoundNumber)) ||
          a.dateTime - b.dateTime
        );
      });

      const uniqFilteredMatches = Array.from(
        new Map(filteredMatches.map((match) => [match["_id"], match])).values()
      );
      return uniqFilteredMatches;
    },
    groupedMatches() {
      const matches = this.filteredMatches;
      this.changeDateTimeToTimezone([
        {
          matches,
        }
      ]);
      const regularRounds = _.filter(
        matches,
        (m) => m.round.type === "Regular"
      );
      const finalRounds = _.filter(matches, (m) => m.round.type === "Final");
      const knockoutRounds = _.filter(
        matches,
        (m) => m.round.type === "Knockout"
      );

      // Get unique round numbers and find the last regular round number
      const mappedRoundNumbers = _.map(regularRounds, "round.number");
      const uniqueRoundNumbers = _.uniq(mappedRoundNumbers);
      const lastRegularRoundNumber = _.max(uniqueRoundNumbers) || 0;
      const unnamedFinalRoundNumbers = _.uniq(
        _.filter(finalRounds, (m) => !m.round.displayName && !m.round.name).map(
          (m) => m.round.number
        )
      );
      const singleUnnamedFinalRound = unnamedFinalRoundNumbers.length <= 1;

      // Set arrange property for sorting
      regularRounds.forEach((item) => {
        item.round.arrange = item.round.number;
      });

      finalRounds.forEach((item) => {
        item.round.arrange =
          item.round.displayName ||
          item.round.name ||
          `Final ${item.round.number}`;
      });

      knockoutRounds.forEach((item) => {
        item.round.arrange = item.round.number + lastRegularRoundNumber;
      });

      // Combine all matches and remove duplicates
      const combinedMatches = [
        ...regularRounds,
        ...finalRounds,
        ...knockoutRounds,
      ].filter(
        (match, index, array) =>
          array.findIndex((m) => m._id === match._id) === index
      );

      // Group matches by round.arrange
      const groupedByRound = _.groupBy(combinedMatches, "round.arrange");

      // Convert to array and add earliest match date for each round
      const groupedRounds = Object.keys(groupedByRound).map((key) => {
        const roundMatches = groupedByRound[key];
        // Find earliest match date in this round for temporal relevance
        const earliestMatch = _.minBy(roundMatches, "dateTime");

        const roundType = _.get(roundMatches[0], "round.type", "");
        const roundOriginalType = _.get(roundMatches[0], "round.originalType", "");
        const roundNumber = _.get(roundMatches[0], "round.number", "");
        const fallbackLabel = roundType === "Regular" || roundOriginalType === "Regular"
          ? (roundNumber === "" ? "Round" : `Round ${roundNumber}`)
          : roundType === "Final"
            ? (singleUnnamedFinalRound ? "Final" : `Final ${roundNumber}`)
            : roundType === "Knockout"
              ? `Knockout ${roundNumber}`
              : `Round ${roundNumber}`;

        return {
          round: _.get(roundMatches[0], "round.arrange"),
          sortOrder: this.getRoundSortOrder(
            roundMatches[0],
            lastRegularRoundNumber
          ),
          dateTime: _.get(earliestMatch, "dateTime", 0),
          matches: roundMatches,
          format:
            _.get(roundMatches[0], "round.displayName") ||
            _.get(roundMatches[0], "round.name") ||
            fallbackLabel,
        };
      });

      return _.orderBy(groupedRounds, "sortOrder", this.roundSortDirection);
    },
  },
  methods: {
    getRoundSortOrder(match, lastRegularRoundNumber = 0) {
      const roundType = _.get(match, "round.type", "");
      const roundNumber = _.get(match, "round.number", 0);

      if (roundType === "Final") {
        return lastRegularRoundNumber + 1000 + roundNumber;
      }

      if (roundType === "Knockout") {
        return lastRegularRoundNumber + roundNumber;
      }

      return roundNumber;
    },
    changeDateTimeToTimezone(pools) {
      const timezoneClients = [21, 22];
      if (!timezoneClients.includes(+process.env.VUE_APP_NATIONAL_ID)) {
        return;
      }
      // eslint-disable-next-line no-restricted-syntax
      for (const pool of pools) {
        const { matches } = pool || {};
        // eslint-disable-next-line no-restricted-syntax
        for (const match of matches) {
          const dateTimeTimezone = utcToZonedTime(match.dateTime, this.timezone);
          match.dateTime = dateTimeTimezone.valueOf();
          match.dateTimeTimezone = dateTimeTimezone;
        }
      }
    },
    getLowestRankOrganization(competition) {
      if (!competition?.orgtree) return null;

      const orgtree = competition.orgtree;
      const ranks = ["club", "association", "state", "national"];

      // Find the lowest rank (highest priority) that exists
      for (const rank of ranks) {
        if (orgtree[rank] && orgtree[rank].name) {
          return {
            name: orgtree[rank].name,
            type: rank.charAt(0).toUpperCase() + rank.slice(1),
          };
        }
      }

      return null;
    },
    matchIsVs(match) {
      return _.get(match, "competitionSettings.type") === "vs";
    },
    async getEventTypes() {
      try {
        const compId = this.competitionId;
        if (!compId) return;
        if (this.eventTypesCache[compId]) {
          this.scoringEventTypes = this.eventTypesCache[compId];
          const hasSelectedEvent = this.scoringEventTypes.some(
            (type) => type.type === +this.eventType
          );
          if (!hasSelectedEvent && this.scoringEventTypes.length > 0) {
            this.eventType = this.scoringEventTypes[0].type;
          }
          return;
        }
        const resEvents = await this.$http.get(
          `assemble/api/v1/live/competitions/${compId}/events`
        );
        this.scoringEventTypes = _.get(
          resEvents,
          "data.data.scoringEvents",
          []
        );
        this.eventTypesCache[compId] = this.scoringEventTypes;
        const hasSelectedEvent = this.scoringEventTypes.some(
          (type) => type.type === +this.eventType
        );
        if (!hasSelectedEvent && this.scoringEventTypes.length > 0) {
          this.eventType = this.scoringEventTypes[0].type;
        }
      } catch (error) {
        console.log("There was an error fetching event types", error);
      }
    },
    async fetchLeaderboard() {
      if (this.currentTab !== "leaderboard" || !this.competitionId || !this.eventType) return;
      const cacheKey = `${this.competitionId}:${this.eventType}`;
      if (this.leaderboardCache[cacheKey]) {
        this.eventLadder = this.leaderboardCache[cacheKey];
        this.eventLadderLoaded = true;
        this.loading = false;
        return;
      }
      if (this.leaderboardRequests[cacheKey]) {
        return this.leaderboardRequests[cacheKey];
      }

      this.leaderboardRequestKey = cacheKey;
      this.loading = true;
      this.eventLadderLoaded = false;

      this.leaderboardRequests[cacheKey] = (async () => {
        try {
          const res = await this.$httpNoAuth.get(
            `/assemble/api/v1/live/leaderboard/competition/${this.competitionId}`,
            { params: { eventType: this.eventType } }
          );
          const data = res.data.data;
          this.leaderboardCache[cacheKey] = data;
          if (this.leaderboardRequestKey === cacheKey) {
            this.eventLadder = data;
            this.key++;
          }
        } catch (e) {
          console.log(e);
        } finally {
          delete this.leaderboardRequests[cacheKey];
          if (this.leaderboardRequestKey === cacheKey) {
            this.loading = false;
            this.eventLadderLoaded = true;
          }
        }
      })();

      return this.leaderboardRequests[cacheKey];
    },
    selectCompetition(competitionId) {
      this.competitionId = competitionId;
      this.$store.commit("matches/setCompetitionId", competitionId);
      this.scrollToActiveElement();
    },
    defaultCompetitionId(preferredId = this.$store.getters["matches/getCompetitionId"]) {
      if (preferredId && _.some(this.competitions, { _id: preferredId })) return preferredId;
      const foundPublic = _.find(this.competitions, (c) => c.display?.public && c.display?.result);
      return foundPublic ? foundPublic._id : _.get(this.competitions[0], "_id");
    },
    forceReload() {
      // This method can be called to force a hard reload when needed on mobile devices
      if (this.$route.query.forceReload) {
        return; // Prevent infinite reloads
      }

      // Add a timestamp query param to force fresh data load
      const timestamp = Date.now();
      const query = { ...this.$route.query, forceReload: timestamp };

      console.log("Forcing page reload to refresh data");
      this.$router
        .replace({
          path: this.$route.path,
          query,
        })
        .catch((err) => {
          if (err.name !== "NavigationDuplicated") {
            throw err;
          }
        });
    },
    scrollToActiveElement() {
      this.$nextTick(() => {
        const chipsContainer = this.$refs.competitionChips;
        const activeElement = chipsContainer
          ? chipsContainer.querySelector(".active")
          : null;

        if (activeElement && chipsContainer) {
          const containerRect = chipsContainer.getBoundingClientRect();
          const elementRect = activeElement.getBoundingClientRect();

          const scrollLeft =
            activeElement.offsetLeft -
            containerRect.width / 2 +
            elementRect.width / 2;
          chipsContainer.scrollTo({
            left: scrollLeft,
            behavior: "smooth",
          });
        }
      });
    },
    getMatchDate(dateTime) {
      return moment(dateTime).tz(this.timezone).format("LLL");
    },
    customArrange() {
      const nationalId = process.env.VUE_APP_NATIONAL_ID;
      const { competitions, seasons } = this;
      const currentSeason = _.find(seasons, { currentSeason: true });
      let arrangementName = [];
      let arrangementId = [];
      let arranged = [];
      if (competitions && nationalId === "8") {
        if (_.get(currentSeason, "_id") === 2022) {
          // arrangementName = [
          //   'Superliga e Meshkujve',
          //   'Superliga e Femrave',
          //   'Liga e ParÃ« Meshkujt',
          //   'Liga e ParÃ« Femrat',
          //   'Liga e KadetÃ«ve (M)',
          //   'Liga e Kadeteve (F)',
          //   'Liga e FatosÃ«ve',
          //   'Liga e Fatoseve',
          //   'Kupa e KosovÃ«s (M)',
          //   'Kupa e KosovÃ«s (F)',
          // ];
          arrangementId = [
            300140, 300141, 300124, 300125, 300138, 300130, 300131, 300128,
            300129, 300135, 300136, 300133, 300134,
          ];
          arrangementId.forEach((item, i) => {
            const comp = _.find(competitions, (c) => c._id === item);
            if (!comp) {
              return;
            }
            arranged.push(comp);
          });
          const compNotInList = _.filter(
            competitions,
            (c) => !arrangementId.includes(c._id)
          );
          compNotInList.forEach((item, i) => {
            arranged.push(item);
          });
          this.competitions = arranged;
          this.competitionId = this.defaultCompetitionId();
        }
      }
      this.key++;
    },
    openMenu() {
      // menuController.enable(true, 'side');
      menuController.open("side");
    },
    openFilterSheet() {
      this.filterSheetOpen = true;
    },
    closeFilterSheet() {
      this.filterSheetOpen = false;
    },
    checkForfeit(type, status, meta, team) {
      if (type === "homeTeam") {
        if (status === "forfeit") {
          const isForfeitingTeam =
            _.get(meta, "forfeitingTeam.name") === _.get(team, "name");
          return isForfeitingTeam ? true : false;
        }
        return false;
      } else if (type === "awayTeam") {
        if (status === "forfeit") {
          const isForfeitingTeam =
            _.get(meta, "forfeitingTeam.name") === _.get(team, "name");
          return isForfeitingTeam ? true : false;
        }
        return false;
      }
    },
    getHomeScore(scores, status, meta, homeTeam) {
      if (status === "forfeit") {
        const competition = _.find(this.competitions, {
          _id: this.competitionId,
        });
        const isForfeitingTeam =
          _.get(meta, "forfeitingTeam.name") === _.get(homeTeam, "name");
        return isForfeitingTeam
          ? 0
          : _.get(competition, "laddertemplate.defaultScoreFFReceived");
      } else {
        return _.get(scores, "homeTeam", 0);
      }
    },
    getAwayScore(scores, status, meta, awayTeam) {
      if (status === "forfeit") {
        const competition = _.find(this.competitions, {
          _id: this.competitionId,
        });
        const isForfeitingTeam =
          _.get(meta, "forfeitingTeam.name") === _.get(awayTeam, "name");
        return isForfeitingTeam
          ? 0
          : _.get(competition, "laddertemplate.defaultScoreFFReceived");
      } else {
        return _.get(scores, "awayTeam", 0);
      }
    },
    // isLastIndex(round, index, groupMatchIndex) {
    //   const nextIndex = index+1;
    //   if(!this.groupedMatches[groupMatchIndex].matches[nextIndex]) return true;
    //   return round.number !== this.groupedMatches[groupMatchIndex].matches[nextIndex].round.number;
    // },
    getByes(round) {
      const res = _.filter(this.byes, (g) => g.round.number === round.number);
      return res;
    },
    // getWeatherIcon(name) {
    //   var images = require.context('../assets/weather-icons/', false, /\.svg$/)
    //   return images('./' + name + ".svg")
    // },
    goMatch(id) {
      if (this.entity && this.entityLevel && this.entityName) {
        this.$router.push(
          `/c/${this.entityLevel}/${this.entityName}/matches/${id}`
        );
        return;
      }
      this.$router.push(`/matches/${id}`);
    },
    goToAS() {
      window.open("https://assemblesports.com", "_blank");
    },
    randomizeAds() {
      const freq = 5;
      const rand = Math.random();
      return rand <= freq / 100;
    },
    // segmentChanged(event) {
    //   this.segment = event.detail.value;
    //   if(this.segment === 'matches'){
    //     this.ladderSegment = 'ladderBoard';
    //   }else{
    //     this.ladderSegment = 'ladderBoard';
    //   }
    // },
    // ladderSegmentChanged(event) {
    //   this.ladderSegment = event.detail.value;
    // },
    // setSegment(){
    //   if (this.filteredMatches.length > 0) this.segment = 'matches';
    //   else if(Object.keys(this.ladder).length > 0) this.segment = 'ladder';
    //   else this.segment = 'matches';
    // },
    gameStatusColor(status) {
      switch (status) {
      case "pre-game":
        return "dark";
      case "final":
        return "success";
      case "forfeit":
      case "washout":
        return "warning";
      case "disputed":
      case "offline":
        return "danger";
      case "first-half":
      case "second-half":
        return "light";
      default:
        return "light";
      }
    },
    selectClosestRound() {
      if (!this.availableRounds || !this.availableRounds.length) return;

      const now = Date.now();
      // Find the round closest to now by date
      const sorted = [...this.availableRounds].sort((a, b) => {
        const aTimeDiff = Math.abs(a.dateTime - now);
        const bTimeDiff = Math.abs(b.dateTime - now);
        return aTimeDiff - bTimeDiff;
      });

      if (sorted.length) {
        const closestRound = sorted[0];
        this.round = closestRound.round;
      }
    },
    scrollToMostRecentRound() {
      if (!this.groupedMatches || !this.groupedMatches.length) return;

      // Find the most recent round with matches that have already started or are about to start
      const now = Date.now();
      const recentRounds = [...this.groupedMatches].sort((a, b) => {
        // Find the closest match date to now (prioritizing future matches that are closest)
        const aTimeDiff = Math.abs(a.dateTime - now);
        const bTimeDiff = Math.abs(b.dateTime - now);
        return aTimeDiff - bTimeDiff;
      });

      if (recentRounds.length) {
        const targetRound = recentRounds[0];

        // Use nextTick to ensure DOM is updated before trying to scroll
        this.$nextTick(() => {
          // Find all round headers
          const allRoundHeaders = document.querySelectorAll("h4.round-text");
          let targetElement = null;

          // Loop through all headers to find the one matching our target format
          for (let i = 0; i < allRoundHeaders.length; i++) {
            if (allRoundHeaders[i].textContent.trim() === targetRound.format) {
              targetElement = allRoundHeaders[i];
              break;
            }
          }

          // If found, scroll to it
          if (targetElement) {
            targetElement.scrollIntoView({ block: "start" });
          }
        });
      }
    },
    async fetchCompetitionData(competitionId, oldCompetitionId) {
      console.log("Fetching competition data");
      console.log({
        competitionId,
        oldCompetitionId,
        currentTab: this.currentTab,
        entity: this.entity,
        isMobile: window.innerWidth < 768,
      });

      if (!competitionId) return;

      try {
        // Always show loading when changing competitions
        this.loading = true;

        // On mobile devices, check if we've transitioned to a different entity
        if (
          window.innerWidth < 768 &&
          this.entity &&
          this.$route.params.entityName &&
          this.entity.name !== this.$route.params.entityName &&
          !this.$route.query.forceReload
        ) {
          console.log(
            "Entity mismatch detected on mobile device, forcing reload"
          );
          this.forceReload();
          return;
        }

        if (this.currentTab === "schedule") {
          // Always reset display flags when changing competitions
          this.displayMatches = true;

          let res = {};

          try {
            res = await this.$http.get(
              `assemble/api/v1/live/matches/competitions/${competitionId}`
            );
          } catch (e) {
            console.log("error fetching matches", e);
            this.displayMatches = false;
            this.matchesLoaded = true;
            this.loading = false;
            throw "An error with getting the competitions has occurred";
          }

          // Update displays and data based on API response
          this.displayMatches = res.data.data.displays.result;
          this.displayLadders = res.data.data.displays.ladder;
          this.competition = res.data.data.competition;

          const { matches, byes } = res.data.data;
          this.matches = matches;
          this.byes = byes;
          this.matchesLoaded = true;

          const foundComp = _.find(this.competitions, { _id: competitionId });
          this.$store.commit(
            "matches/setLaddertemplate",
            foundComp ? foundComp.laddertemplate : null
          );
        }

        // Fetch additional data based on current tab
        if (this.currentTab === "ladder") {
          const resLadder = await this.$httpNoAuth.get(
            `/assemble/api/v1/live/ladders/competition/${competitionId}`
          );
          this.ladder = Object.assign({}, resLadder.data.data);
        }

        this.key++;

        // Auto-select the closest round and scroll to it
        this.$nextTick(() => {
          this.selectClosestRound();
          // Give a small delay to ensure rendering is complete
          setTimeout(() => {
            this.scrollToMostRecentRound();
          }, 100);
        });
      } catch (error) {
        console.error("Error fetching competition data:", error);
      } finally {
        if (this.currentTab !== "leaderboard") {
          this.loading = false;
        }
        if (this.currentTab === "schedule") {
          this.matchesLoaded = true;
        }
        this.$forceUpdate();
      }
    },
    getSelectedCompetitionName() {
      const competition = this.competitions?.find(
        (c) => c._id === this.competitionId
      );
      return competition ? competition.name : null;
    },
    getSelectedRoundName() {
      const round = this.availableRounds?.find((r) => r.round === this.round);
      return round ? round.format : "All Rounds";
    },
    clearSearch() {
      this.competitionSearchQuery = "";
    },
  },
  watch: {
    // Add a watch for route changes to detect navigation between different club URLs
    $route: {
      immediate: true,
      async handler(newRoute, oldRoute) {
        // Handle the forceReload query parameter if present
        if (newRoute.query.forceReload && !oldRoute?.query.forceReload) {
          console.log("Force reload detected, resetting data");
          this.loading = true;

          await this.$nextTick();
          await this.customArrange();

          this.loading = false;
          return;
        }

        // Check if navigation is between different entities
        if (
          oldRoute &&
          (newRoute.params.entityName !== oldRoute.params.entityName ||
            newRoute.params.entityLevel !== oldRoute.params.entityLevel)
        ) {
          console.log("Route changed between entities, refreshing data");
          this.loading = true;

          // Wait for the next tick to ensure entity data is available
          await this.$nextTick();

          // Set current tab based on route
          const path = this.$route.path;
          if (path.includes("/ladders")) {
            this.currentTab = "ladder";
          } else if (path.includes("/leaderboard")) {
            this.currentTab = "leaderboard";
          } else if (path.includes("/schedule")) {
            this.currentTab = "schedule";
          } else {
            this.currentTab = this.$store.getters["matches/currentTab"];
          }

          // Reset data and fetch competition data
          this.compListOpen = false;
          this.competitionId = null;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];
          this.displayMatches = true;
          this.displayLadders = true;

          // Wait for entity data to be available
          await this.$nextTick();
          await this.customArrange();

          // On mobile devices, we might need to force a hard reload
          // Check if we're on a mobile device by looking at screen width
          if (
            window.innerWidth < 768 &&
            !newRoute.query.forceReload &&
            newRoute.params.entityName !== oldRoute.params.entityName
          ) {
            setTimeout(() => {
              // Delay the force reload to allow the initial navigation to complete
              this.forceReload();
            }, 100);
          }

          this.loading = false;
        }
      },
    },
    "$store.state.national.seasons": {
      handler: function (seasons) {
        if (seasons && seasons.length > 0) {
          // Use global season from ui store (set from presentation-settings or currentSeason)
          const storedSeason = this.$store.getters["ui/season"];

          if (storedSeason) {
            this.filterSeason = storedSeason;
          } else {
            // Fallback to currentSeason flag
            const currentSeason = seasons.find((season) => season.currentSeason);
            if (currentSeason) {
              this.filterSeason = currentSeason._id;
            }
          }
        }
      },
      immediate: true,
    },
    // Watch for global season changes from other pages
    "$store.state.ui.season": {
      handler(newSeason) {
        if (newSeason && newSeason !== this.filterSeason) {
          this.filterSeason = newSeason;
        }
      },
      immediate: true
    },
    round(name) {
      this.$store.commit("matches/setRound", name);
    },
    team(name) {
      this.$store.commit("matches/setTeam", name);
    },
    filterSeason: {
      async handler(id) {
        if (!id) return;

        try {
          this.loading = true;

          // Preserve the currently selected/restored competition so the season
          // refetch below doesn't clobber it with the default competition.
          const preservedCompetitionId =
            this.competitionId ?? this.$store.getters["matches/getCompetitionId"];

          // Reset competition data
          this.competitionId = undefined;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];

          // Store selected season in Vuex
          this.$store.dispatch("ui/updateSeason", { season: id });

          // Fetch competitions for season
          let resComp;
          let currentTab = ''
          const path = this.$route.path;
          if (path.includes("/ladders")) {
            currentTab = "ladder";
          }
          if (this.entity && this.entity._id) {
            resComp = await this.$http.get(
              "assemble/api/v1/live/competitions",
              {
                params: {
                  season: id,
                  entityType: this.entity.level,
                  entityId: this.entity._id,
                  gameType: this.gameType,
                  currentTab,
                },
              }
            );
          } else {
            resComp = await this.$http.get(
              "assemble/api/v1/live/competitions",
              {
                params: {
                  season: id,
                  gameType: this.gameType,
                  currentTab,
                },
              }
            );
          }

          this.competitions = resComp.data.data;

          // Set competition ID, preferring the previously selected/restored one
          // if it's still present in the newly fetched competitions
          if (this.competitions.length) {
            this.competitionId = this.defaultCompetitionId(preservedCompetitionId);
          }

          if (this.scoringTypes?.length > 0) {
            console.log("---- setting event type ----");
            this.eventType = this.scoringTypes[0].type;
          }

          this.customArrange();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
      immediate: true,
    },
    gameType: {
      immediate: true,
      async handler(newGameType) {
        if (!newGameType) return;

        try {
          this.loading = true;

          // Preserve the currently selected/restored competition so the game
          // type refetch below doesn't clobber it with the default competition.
          const preservedCompetitionId =
            this.competitionId ?? this.$store.getters["matches/getCompetitionId"];

          // Reset competition data
          this.competitionId = undefined;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];

          // Fetch competitions for the new game type
          let resComp;
          let currentTab = ''
          const path = this.$route.path;
          if (path.includes("/ladders")) {
            currentTab = "ladder";
          }
          if (this.entity && this.entity._id) {
            resComp = await this.$http.get(
              "assemble/api/v1/live/competitions",
              {
                params: {
                  season: this.filterSeason,
                  entityType: this.entity.level,
                  entityId: this.entity._id,
                  gameType: this.gameType,
                  currentTab,
                },
              }
            );
          } else {
            resComp = await this.$http.get(
              "assemble/api/v1/live/competitions",
              {
                params: {
                  season: this.filterSeason,
                  gameType: this.gameType,
                  currentTab,
                },
              }
            );
          }

          this.competitions = resComp.data.data;

          // Set competition ID, preferring the previously selected/restored one
          // if it's still present in the newly fetched competitions
          if (this.competitions.length) {
            this.competitionId = this.defaultCompetitionId(preservedCompetitionId);
          }

          if (this.scoringTypes?.length > 0) {
            console.log("---- setting event type ----");
            this.eventType = this.scoringTypes[0].type;
          }

          await this.customArrange();
        } catch (error) {
          console.log(error);
        } finally {
          this.loading = false;
        }
      },
    },
    eventType: {
      handler() {
        if (this.currentTab === "leaderboard") this.fetchLeaderboard();
      },
    },
    competitionId: {
      async handler(id, oldId) {
        if (!id) return;

        try {
          console.log("Competition ID changed:", id, "from", oldId);

          if (this.currentTab === "ladder") {
            this.ladder = {};
            this.loading = true;
            const resLadder = await this.$httpNoAuth.get(
              `/assemble/api/v1/live/ladders/competition/${id}`
            );
            this.ladder = Object.assign({}, resLadder.data.data);
            this.loading = false;
          } else if (this.currentTab === "leaderboard") {
            await this.getEventTypes();
            await this.fetchLeaderboard();
          } else {
            await this.fetchCompetitionData(id, oldId);
          }

          this.$store.dispatch("ui/updateCompetitionId", { competitionId: id });
          this.scrollToActiveElement();
        } catch (error) {
          console.error("Error fetching competition data:", error);
          this.loading = false;
        }
      },
    },
    currentTab: {
      immediate: true,
      deep: true,
      handler(newTab, oldTab) {
        console.log("newTab", newTab);

        // Only run this logic when actually changing tabs (not on initial load)
        if (oldTab && newTab !== oldTab) {
          // Get the current season from store before any updates happen
          const storedSeason = this.$store.getters["ui/season"];
          console.log("storedSeason", storedSeason);

          // Store the current season in a local variable to prevent it from being overwritten
          const currentSeason = storedSeason || this.filterSeason;

          // Use nextTick to ensure this runs after Vue has processed other updates
          this.$nextTick(() => {
            if (currentSeason && currentSeason !== this.filterSeason) {
              this.filterSeason = currentSeason;
            }

            if (this.competitionId) {
              if (this.currentTab === "leaderboard") {
                this.getEventTypes().then(() => this.fetchLeaderboard());
              } else {
                this.fetchCompetitionData(this.competitionId);
              }
            }
          });
        }
      },
    },
    entity: {
      immediate: true,
      deep: true,
      async handler(newEntity, oldEntity) {
        if (newEntity && (!oldEntity || newEntity._id !== oldEntity._id)) {
          console.log("Entity changed, refreshing competitions data");
          this.loading = true;

          // Preserve the currently selected/restored competition so the entity
          // refetch below doesn't clobber it with the default competition.
          const preservedCompetitionId =
            this.competitionId ?? this.$store.getters["matches/getCompetitionId"];

          // Reset data
          this.compListOpen = false;
          this.competitionId = undefined;
          this.competition = {};
          this.matches = [];
          this.byes = [];
          this.ladder = {};
          this.eventLadder = [];

          // Wait for next tick to ensure entity data is available
          await this.$nextTick();

          if (this.currentTab === "schedule") {
            // Fetch competitions for the new entity
            try {
              const resComp = await this.$http.get(
                "assemble/api/v1/live/competitions",
                {
                  params: {
                    season: this.filterSeason,
                    entityType: newEntity.level,
                    entityId: newEntity._id,
                    gameType: this.gameType,
                  },
                }
              );

              this.competitions = resComp.data.data;
              if (this.competitions.length > 0) {
                this.competitionId = this.defaultCompetitionId(preservedCompetitionId);
              }

              await this.customArrange();
            } catch (error) {
              console.log("Error fetching competitions:", error);
            }
          }

          this.loading = false;
        }
      },
    },
  },
};
</script>
<style scoped lang="scss">
ion-title {
  font-family: "Cairo";
}

// Compact Filter Preview - Clean bottom design
// Sticky Filters Section
.sticky-filters {
  position: -webkit-sticky;
  position: sticky;
  top: 0;
  z-index: 100;
  background: rgba(0, 0, 0, 0.95);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);
  padding: 0.5rem 0;

  @media (max-width: 768px) {
    padding: 0.4rem 0;
    // Fix mobile scroll issues by ensuring proper containment
    contain: layout style;
    will-change: transform;
    transform: translateZ(0);
  }
}

// Competition Pill Styles
.competition-pill {
  position: relative;
  margin: 0 1.25rem 0.5rem 1.25rem;

  @media (max-width: 768px) {
    margin: 0 1rem 0.4rem 1rem;
  }
}

.pill-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 1rem 1.25rem;
  background: rgba(255, 255, 255, 0.04);
  border: 1px solid rgba(255, 255, 255, 0.12);
  border-radius: 50px;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);
  }

  &:active {
    transform: translateY(0);
  }

  @media (max-width: 768px) {
    padding: 0.875rem 1rem;
    gap: 0.5rem;
  }
}

.pill-icon {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.7);
  flex-shrink: 0;

  @media (max-width: 768px) {
    font-size: 1rem;
  }
}

.pill-text {
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.95rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  flex: 1;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
}

.pill-chevron {
  font-size: 1rem;
  color: rgba(255, 255, 255, 0.6);
  flex-shrink: 0;
  transition: transform 0.2s ease;

  @media (max-width: 768px) {
    font-size: 0.9rem;
  }
}

// Round Pills Section
.rounds-section {
  margin: 0 1.25rem 1rem 1.25rem;

  @media (max-width: 768px) {
    margin: 0 1rem 0.75rem 1rem;
  }
}

.rounds-scroll {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  padding: 0.5rem 0;
  scroll-behavior: smooth;

  // Hide scrollbar but keep functionality
  scrollbar-width: none;
  -ms-overflow-style: none;
  &::-webkit-scrollbar {
    display: none;
  }
}

.round-pill {
  display: flex;
  align-items: center;
  padding: 0.5rem 1rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 8px;
  color: rgba(255, 255, 255, 0.7);
  font-size: 0.85rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  white-space: nowrap;
  cursor: pointer;
  transition: all 0.15s ease;
  min-width: fit-content;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.9);
  }

  &.active {
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.3);
    color: rgba(255, 255, 255, 0.95);
    font-weight: 600;
  }

  @media (max-width: 768px) {
    padding: 0.4rem 0.8rem;
    font-size: 0.8rem;
  }
}

// Season Filter Sheet
.season-filter-sheet {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  background: rgba(0, 0, 0, 0.3);
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  &.expanded {
    max-height: 200px;

    @media (max-width: 768px) {
      max-height: 180px;
    }
  }
}

.sheet-content {
  padding: 1.5rem 1.25rem;

  @media (max-width: 768px) {
    padding: 1rem 1rem;
  }
}

.sheet-header {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;

  @media (max-width: 768px) {
    margin-bottom: 0.75rem;
  }
}

.sheet-icon {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.7);

  @media (max-width: 768px) {
    font-size: 1rem;
  }
}

.sheet-title {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;

  @media (max-width: 768px) {
    font-size: 0.85rem;
  }
}

// Top row for season and competition
.top-selectors-row {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  margin-bottom: 1.5rem;

  @media (max-width: 768px) {
    display: grid;
    grid-template-columns: 1fr 2fr;
    gap: 1rem;
    margin-bottom: 0.75rem;

    .season-selector {
      margin-bottom: 0;
    }

    .competition-selector {
      margin-bottom: 0;
    }
  }

  @media (max-width: 480px) {
    display: flex;
    flex-direction: column;
    gap: 0.75rem;
  }
}

.selector-label {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  margin-bottom: 0.75rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.875rem;
  font-weight: 400;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  letter-spacing: 0.02em;

  .label-icon {
    font-size: 1.1rem;
    color: rgba(255, 255, 255, 0.65);
    transition: color 0.2s ease;
  }

  @media (max-width: 768px) {
    margin-bottom: 0.5rem;
    font-size: 0.8rem;
    gap: 0.4rem;

    .label-icon {
      font-size: 0.9rem;
    }
  }
}

.selector-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 0.75rem;

  @media (max-width: 768px) {
    margin-bottom: 0.5rem;
  }
}

.competition-chips,
.round-chips,
.pool-chips {
  display: flex;
  gap: 0.5rem;
  overflow-x: auto;
  scroll-behavior: smooth;
  padding: 0.25rem;

  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none;
  scrollbar-width: none;

  @media (max-width: 768px) {
    gap: 0.3rem 0;
    padding: 0.15rem;
  }
}

@keyframes slideIn {
  from {
    width: 0;
    opacity: 0;
  }
  to {
    width: 20px;
    opacity: 1;
  }
}

// Responsive Design
@media (max-width: 768px) {
  .selection-container {
    padding: 0;
  }

  .competition-selector,
  .round-selector,
  .pool-selector {
    margin-bottom: 1.25rem;
  }

  .season-selector {
    margin-bottom: 0;
  }

  .competition-chip,
  .round-chip,
  .pool-chip {
    padding: 0.625rem 0.875rem;
    min-height: 2.25rem;

    .chip-text {
      font-size: 0.8rem;
    }
  }
}

// Existing styles with improvements
ion-grid {
  white-space: nowrap;
  --offset-bottom: auto !important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
}

// Professional Header Styles
.sleek-header {
  --background: rgba(0, 0, 0, 0.4);
  --color: white;
  --border-width: 0;
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  border-bottom: 1px solid rgba(255, 255, 255, 0.12);
  padding: 0.875rem 1rem;
  min-height: 4rem;
  position: relative;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;

  @media (max-width: 768px) {
    padding: 0.5rem 0.75rem;
    min-height: 3.5rem;
  }
}

.sleek-title {
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  font-weight: 500;
  font-size: 1.2rem;
  letter-spacing: 0.02em;
  color: rgba(255, 255, 255, 0.95);
  text-align: center;
  position: relative;
  line-height: 1.3;

  @media (max-width: 768px) {
    font-size: 1.1rem;

    &::after {
      width: 30px;
    }
  }
}

.menu-button {
  --color: rgba(255, 255, 255, 0.8);
  --color-hover: rgba(255, 255, 255, 0.95);
  --background-hover: rgba(255, 255, 255, 0.08);
  --border-radius: 12px;
  height: 2.75rem;
  width: 2.75rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  margin-right: 1rem;

  &:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0px);
  }

  @media (max-width: 768px) {
    height: 2.5rem;
    width: 2.5rem;
  }
}

.menu-icon {
  font-size: 1.4rem;
  position: relative;
  transition: all 0.2s ease;
  color: rgba(255, 255, 255, 0.85);

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
}

// Removed header-accent for cleaner professional look

.round-text {
  color: rgba(255, 255, 255, 0.9);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;
  text-align: center;
  font-size: 14px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 1rem 0 0.75rem 0;
}

.competition-section-desktop {
  display: block;
  padding: 0 1.5rem;

  @media screen and (max-width: 1080px) {
    display: none;
  }
}

// Desktop Table Layout Styles - Enhanced Readability
.matches-table-section {
  margin-bottom: 2rem;

  // Professional glassmorphism container with warmer tones
  background: linear-gradient(
    135deg,
    rgba(20, 20, 22, 0.3) 0%,
    rgba(15, 15, 17, 0.2) 100%
  );
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  overflow: hidden;

  // Subtle upward glow for depth
  box-shadow: 0 -1px 20px rgba(0, 0, 0, 0.15);
}

.round-header-desktop {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1rem 1.5rem;
  background: linear-gradient(
    135deg,
    rgba(255, 252, 245, 0.06) 0%,
    rgba(255, 255, 255, 0.03) 100%
  );
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  .round-title {
    color: white;
    font-size: 1.1rem;
    font-weight: 600;
    margin: 0;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;

    // Gold gradient text
    background: linear-gradient(135deg, #ffd700, #ffed4e);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
  }

  .round-meta {
    .match-count {
      color: #b8bcc3;
      font-size: 0.8rem;
      font-weight: 500;
      text-transform: uppercase;
      letter-spacing: 0.05em;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }
  }
}

.matches-table-header {
  display: grid;
  grid-template-columns: 140px 1fr 120px 120px 200px;
  gap: 1rem;
  padding: 0.875rem 1.5rem;
  background: rgba(255, 252, 245, 0.04);
  border-bottom: 1px solid rgba(255, 255, 255, 0.08);

  .table-col {
    color: #d1d5db;
    font-size: 0.75rem;
    font-weight: 600;
    text-transform: uppercase;
    letter-spacing: 0.1em;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  }

  .col-time {
    text-align: left;
  }
  .col-teams {
    text-align: left;
  }
  .col-score {
    text-align: center;
  }
  .col-status {
    text-align: center;
  }
  .col-venue {
    text-align: right;
  }
}

.matches-table-body {
  // Table rows will be styled in MatchCardDesktop component
}

// Byes section styling
.byes-section {
  margin-top: 1rem;
  padding: 1rem 1.5rem;
  background: rgba(255, 252, 245, 0.03);
  border-top: 1px solid rgba(255, 255, 255, 0.08);

  .byes-header {
    margin-bottom: 0.75rem;

    .byes-title {
      color: #e5e7eb;
      font-size: 0.9rem;
      font-weight: 600;
      margin: 0;
      font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
    }
  }

  .byes-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(150px, 1fr));
    gap: 0.75rem;

    .bye-team {
      display: flex;
      align-items: center;
      gap: 0.5rem;
      padding: 0.5rem;
      background: rgba(255, 252, 245, 0.04);
      border-radius: 8px;

      .bye-team-name {
        color: #d1d5db;
        font-size: 0.8rem;
        font-weight: 500;
        font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
      }
    }
  }
}
.competition-section {
  display: grid;
  grid-template-columns: 1fr;
  min-width: 0;

  > div { min-width: 0; }

  @media screen and (min-width: 1080px) {
    display: none;
  }

  // on larger screen make it bigger
  @media only screen and (min-width: 768px) {
    //   grid-template-columns: repeat(auto-fit, minmax(40rem, 1fr));
    padding: 0.75rem;
  }
  // gap: 0.5rem;
  // padding: 1rem 1rem;
  .competition-option {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background: #17181b;
    border-radius: 1rem;
    // padding: 1rem 1rem;
  }
}

.competition-row {
  --offset-bottom: auto !important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  background: $background !important;
}

.date-row {
  align-items: center;
  --offset-bottom: auto !important;
  --overflow: hidden;
  overflow: auto;
  &::-webkit-scrollbar {
    display: none;
  }
  padding: 1rem 1.5rem;
  background: $background !important;
  border-bottom: 1px solid #3a3a3a;
}

.chip {
  font-size: 1rem;
  color: #a9a9a9;
  font-family: "Cairo";
  &.active {
    background: #4caf50;
    color: white;
    // color: var(--ion-color-primary);
    font-family: "Cairo";
  }

  &.selectable {
    cursor: pointer;
    color: #a9a9a9;
    background: #1e1f22;
  }
}

.dateOption {
  display: flex;
  flex-direction: column;
  align-items: center;
  // gap: 0.25rem;
  span {
    color: #a9a9a9;
    font-size: 0.8rem;
    font-family: "Cairo";
    transition: all 0.2s ease-in-out;
  }

  .date {
    font-size: 1rem;
  }

  &.active {
    // background: white;
    // color: var(--ion-color-primary);
    span {
      // font-size: 0.9rem;
      color: white !important;
      font-family: "Cairo";
    }
  }

  &.selectable {
    cursor: pointer;
    color: #fff;
    // background: #1E1F22;
  }
}

.display-round-byes {
  font-size: 10px;
  color: rgba(255, 196, 37, 0.9);
  padding: 5px;
  position: absolute;
  top: -30px;
  left: 20px;
  background: #1e1f22;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}

.display-round {
  font-size: 10px;
  color: rgba(255, 196, 37, 0.9);
  padding: 5px;
  position: absolute;
  top: -32px;
  left: 40px;
  background: #1e1f22;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
ion-item {
  --padding-start: 15px;
  --padding-end: 15px;
}
.flex {
  display: flex;
}
.flex-column {
  flex-direction: column;
}
.align-center {
  align-items: center;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.justify-around {
  justify-content: space-around;
}
// .light-text {
//   font-size: 14px;
//   font-weight: 400;
//   text-transform: capitalize;
// }
// .normal-text {
//   font-size: 15px;
//   font-weight: 600;
//   text-transform: capitalize;
// }
.bold-text {
  font-size: 16px;
  font-weight: bold;
}
.score-text {
  font-size: 30px;
  line-height: 30px;
  font-weight: 700;
  /* color: rgba(8, 48, 109, 0.5); */
  color: white;
}

.header {
  --background: #1a2933 !important;
  color: white;
}

.custom-segment {
  background: $background !important;
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .segment-button-checked {
  color: $primary;
  --indicator-box-shadow: none;
  border-bottom: 2px solid $primary;
}

.bye-card {
  margin-inline: 1.5rem;
  position: relative;
  border-radius: 24px;
  cursor: pointer;
  max-width: 100%;
  overflow: hidden;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);

  font-family: "BrownStd-Regular";
  color: white;
  box-shadow: none;
  background: #171717 !important;
  .round-text {
    margin-top: 0.5rem;
    margin-bottom: 1rem;
  }
}
.custom-card {
  border-radius: 24px;
  cursor: pointer;
  // box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  // -webkit-box-shadow: inset 0 0 0 1000px rgba(117, 125, 138, .25);
  font-family: "BrownStd-Regular";
  font-size: 1.2rem;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: white;
  // background: transparent;
  box-shadow: none;
  background: #171717 !important;
  margin-inline: 1.5rem;

  .venue {
    letter-spacing: -0.01rem;
  }
}
.custom-card .card-content-ios {
  padding: 10px;
}

.custom-card .promoted-header {
  font-family: "BrownStd-Regular";
  text-align: center;
  font-size: 0.9rem;
  font-weight: 600;
  text-transform: capitalize;
  line-height: 137.4%;
  letter-spacing: 0.02em;
  color: #2d3a45;
}

.list-ios,
.list-md {
  padding: 0;
  background: 0;
}

ion-item {
  --background: #232528;
  --color: white;
}

.custom-segment {
  border: none;
  /* background: white; */
  border-radius: 0px;
  border-bottom: 1px solid rgba(177, 177, 177, 0.3);
  padding-top: 1rem;
  border: none;
  background: none;
  display: flex;
  // justify-content: center;
  /* border-radius: 1rem !important; */
}

.custom-segment ::before {
  border-left: none;
}

.custom-segment .in-segment {
  color: rgba(177, 177, 177, 1);
  font-size: 1.3rem;
  // background-color: rgba($primary, .7);
}

.custom-segment .segment-button-checked {
  color: rgb(234 68 68);
  border-radius: 0;
  margin-bottom: 0;
  // background-color: rgba($primary, .7);
  color: $highlight;
  font-size: 1.3rem;
  font-weight: 500;
  --indicator-height: 0;
  --indicator-box-shadow: none;
  /* --indicator-color: rgb(234, 68, 68, 0.7);
  --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1); */
  border-bottom: 3px solid $highlight;
}
.custom-segment-ladder {
  // border: none;
  margin: 0 auto;
  margin-top: 1rem;
  display: flex;
  width: 70%;
  justify-content: center;
  border-radius: 0.6rem !important;
}

.custom-segment-ladder-button {
  flex-basis: 50%;
}

.custom-segment-ladder ::before {
  border-left: none;
}

.custom-segment-ladder .in-segment {
  color: rgba(177, 177, 177, 1);
  background-color: rgba($primary, 0.2);
}

.custom-segment-ladder .segment-button-checked {
  color: rgb(234 68 68);
  // margin-bottom: 0;
  background-color: rgba($primary, 0.7);
  color: $highlight;
  font-weight: 400;
  // --indicator-height: 0;
  // --indicator-box-shadow: none;
  //  --indicator-color: rgb(234, 68, 68, 0.7);
  // --indicator-transform:translate3d(0, 25px, 0) scale3d(.7,1,1);
  // border-bottom: 3px solid $highlight;
}

.empty-container {
  height: 60vh;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-container ion-card {
  padding: 4rem;
  border-radius: 1rem;
  background: transparent;
  box-shadow: none;
  -webkit-box-shadow: none;
}

.empty-placeholder {
  align-items: flex-start;
  font-family: "BrownStd-Regular";
  font-style: normal;
  font-weight: bold;
  font-size: 1.2rem;
  line-height: 137.4%;
  /* margin-bottom: 1rem; */
  padding-left: 0;

  letter-spacing: 0.02em;

  color: white;
}

.team-name {
  font-size: 0.8rem;
  white-space: break-spaces;
}

ion-select::part(icon) {
  margin-left: 0.5rem;
  color: white !important;
  opacity: 0.85;
}

.elapseTime {
  font-size: 1.5rem;
}

// General styles
.custom-segment ion-label {
  margin-bottom: 0;
}

ion-content {
  background: $background;
  --background: $background;
}

ion-content::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: rgba(0, 0, 0, 0.3);
}

ion-content::-webkit-scrollbar {
  width: 0.35rem;
  background-color: rgba(0, 0, 0, 0.3);
}

@media only screen and (max-width: 768px) {
  ion-content::-webkit-scrollbar {
    width: 0.15rem;
    background-color: rgba(0, 0, 0, 0.3);
  }
}

ion-content::-webkit-scrollbar-thumb {
  background-color: #888;
}

.overlay {
  background: $background;
  padding: 0rem;
}

ion-toolbar,
ion-item {
  --border-width: 0 !important;
  --background: $background;
  --color: white;
}

ion-segment-button {
  --background-hover: white !important;
  --color-hover: $highlight !important;
  --color-checked: $highlight !important;
}

h1,
h2,
h3,
h4 {
  margin-top: 0;
}

// Competition Dropdown Styles
.competitions-dropdown {
  position: absolute;
  top: clamp(8rem, 5vmax, 15rem);
  left: 0;
  right: 0;
  z-index: 1000;
  margin-top: 0.5rem;
  padding: 1rem;
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.95) 0%,
    rgba(0, 0, 0, 0.9) 100%
  );
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  border-radius: 16px;
  // border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  max-height: 75vh;
  overflow: scroll;
  animation: dropdownSlideIn 0.3s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  @media (max-width: 768px) {
    left: 1rem;
    right: 1rem;
  }
}

@keyframes dropdownSlideIn {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@keyframes staggeredSlideIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.competitions-list {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  max-height: calc(100vh - 20rem);
  overflow-y: auto;
  padding-bottom: 6rem; // Add padding to prevent footer from covering last items

  // Custom scrollbar styling
  &::-webkit-scrollbar {
    width: 4px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
  }

  &::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.2);
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
  }
}

.competition-item {
  // Compact glassmorphism with list-style appearance
  background: linear-gradient(
    135deg,
    rgba(0, 0, 0, 0.25) 0%,
    rgba(0, 0, 0, 0.15) 100%
  );

  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 24px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  min-height: 48px;
  width: 100%;
  display: block;

  // Matching selection-container backdrop blur
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);

  // Subtle shadow
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.1);

  // Staggered entrance animation
  opacity: 0;
  transform: translateY(10px);
  animation: staggeredSlideIn 0.4s cubic-bezier(0.4, 0, 0.2, 1) forwards;

  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);

  &:hover {
    border-color: rgba(255, 255, 255, 0.2);
    transform: translateY(-1px);

    background: linear-gradient(
      135deg,
      rgba(0, 0, 0, 0.2) 0%,
      rgba(0, 0, 0, 0.12) 100%
    );

    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0);
  }

  &.selected {
    border-left: 3px solid #4caf50;
    border-color: rgba(76, 175, 80, 0.2);

    background: linear-gradient(
      135deg,
      rgba(76, 175, 80, 0.04) 0%,
      rgba(0, 0, 0, 0.12) 100%
    );

    box-shadow: 0 2px 6px rgba(76, 175, 80, 0.08);

    // Subtle glow effect
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      bottom: 0;
      width: 2px;
      background: linear-gradient(to bottom, #4caf50, rgba(76, 175, 80, 0.3));
      box-shadow: 0 0 8px rgba(76, 175, 80, 0.3);
    }
  }
}

.item-content {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  padding: 0.75rem 1rem;
  min-height: 48px;
  width: 100%;
  box-sizing: border-box;
}

.competition-icon {
  font-size: 1.2rem;
  color: rgba(255, 255, 255, 0.6);
  flex-shrink: 0;
  transition: all 0.2s ease;

  .competition-item:hover & {
    color: rgba(255, 255, 255, 0.8);
  }

  .competition-item.selected & {
    color: #4caf50;
  }
}

.competition-name {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  font-weight: 500;
  margin: 0;
  line-height: 1.4;
  letter-spacing: -0.005em;
  word-wrap: break-word;
  flex: 1;
  min-width: 0;
  min-height: 20px;
  display: flex;
  align-items: center;

  // Professional system font stack matching selection-container
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", "Roboto",
    "Helvetica Neue", Arial, sans-serif;

  transition: color 0.2s ease;

  .competition-item:hover & {
    color: rgba(255, 255, 255, 0.95);
  }

  .competition-item.selected & {
    color: white;
  }
}

.selection-indicator {
  display: flex;
  align-items: center;
  color: #4caf50;
  flex-shrink: 0;
  margin-left: auto;

  ion-icon {
    font-size: 1.1rem;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.filter-sheet {
  width: 100%;
  max-height: 70vh;
  background: linear-gradient(
    135deg,
    rgba(20, 20, 22, 0.95) 0%,
    rgba(15, 15, 17, 0.95) 100%
  );
  backdrop-filter: blur(30px) saturate(180%);
  -webkit-backdrop-filter: blur(30px) saturate(180%);
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-bottom: none;
  animation: slideUp 0.3s cubic-bezier(0.4, 0, 0.2, 1);

  @media (min-width: 768px) {
    max-width: 500px;
    margin: 0 auto;
    border-radius: 24px;
    border: 1px solid rgba(255, 255, 255, 0.15);
    max-height: 60vh;
    margin-bottom: 2rem;
  }
}

@keyframes slideUp {
  from {
    transform: translateY(100%);
  }
  to {
    transform: translateY(0);
  }
}

.filter-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 1.5rem 1rem 1.5rem;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
}

.filter-title {
  color: white;
  font-size: 1.4rem;
  font-weight: 600;
  margin: 0;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.close-button {
  --color: rgba(255, 255, 255, 0.9);
  --background-hover: rgba(255, 255, 255, 0.15);
  width: 3rem;
  height: 3rem;
  min-width: 3rem;
  min-height: 3rem;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);

  ion-icon {
    font-size: 1.6rem;
  }

  @media (max-width: 768px) {
    width: 3.25rem;
    height: 3.25rem;
    min-width: 3.25rem;
    min-height: 3.25rem;

    ion-icon {
      font-size: 1.8rem;
    }
  }
}

.filter-content {
  padding: 1.5rem;
  // Let parent container handle scrolling
  // max-height: 50vh;
  // overflow-y: auto;
}

.filter-section {
  margin-bottom: 2rem;

  &:last-child {
    margin-bottom: 0;
  }
}

.filter-label {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  margin-bottom: 1rem;
  color: rgba(255, 255, 255, 0.9);
  font-size: 1rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
}

.filter-icon {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.7);
}

.filter-select {
  --color: white !important;
  --placeholder-color: rgba(255, 255, 255, 0.6) !important;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 12px;
  padding: 0.75rem 1rem;
  color: white;

  &::part(text) {
    color: white !important;
  }

  &::part(icon) {
    color: rgba(255, 255, 255, 0.6) !important;
  }
}

.status-chips {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
}

.status-chip {
  padding: 0.75rem 1.25rem;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  color: rgba(255, 255, 255, 0.8);
  font-size: 0.9rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: rgba(255, 255, 255, 0.25);
    color: rgba(255, 255, 255, 0.95);
    transform: translateY(-1px);
  }

  &.active {
    background: rgba(76, 175, 80, 0.2);
    border-color: rgba(76, 175, 80, 0.4);
    color: white;
    transform: translateY(-1px);
  }
}

// Filter Button Styles
.filter-button {
  --color: rgba(255, 255, 255, 0.8);
  --color-hover: rgba(255, 255, 255, 0.95);
  --background-hover: rgba(255, 255, 255, 0.08);
  --border-radius: 12px;
  height: 2.75rem;
  width: 2.75rem;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  background: rgba(255, 255, 255, 0.05);
  border: 1px solid rgba(255, 255, 255, 0.1);
  border-radius: 12px;
  margin-left: 1rem;

  &:hover {
    transform: translateY(-1px);
    background: rgba(255, 255, 255, 0.1);
    border-color: rgba(255, 255, 255, 0.2);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  }

  &:active {
    transform: translateY(0px);
  }

  @media (max-width: 768px) {
    height: 2.5rem;
    width: 2.5rem;
  }
}

.filter-icon {
  font-size: 1.4rem;
  position: relative;
  transition: all 0.2s ease;
  color: rgba(255, 255, 255, 0.85);

  @media (max-width: 768px) {
    font-size: 1.3rem;
  }
}

// Fix for all ion-select elements in the component
ion-select {
  --color: white !important;
  --placeholder-color: rgba(255, 255, 255, 0.6) !important;
  color: white !important;

  &::part(text) {
    color: white !important;
  }

  &::part(icon) {
    color: rgba(255, 255, 255, 0.6) !important;
  }
}

ion-select-option {
  --color: white !important;
}

// Search Container Styles
.search-container {
  margin-bottom: 1rem;
  padding: 0 0.5rem;
}

.search-input-wrapper {
  display: flex;
  align-items: center;
  background: rgba(255, 255, 255, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.15);
  border-radius: 50px;
  padding: 0.75rem 1rem;
  transition: all 0.2s ease;

  &:focus-within {
    background: rgba(255, 255, 255, 0.12);
    border-color: rgba(255, 255, 255, 0.25);
    box-shadow: 0 0 0 2px rgba(255, 255, 255, 0.1);
  }
}

.search-icon {
  font-size: 1.1rem;
  color: rgba(255, 255, 255, 0.6);
  flex-shrink: 0;
  margin-right: 0.75rem;
}

.search-input {
  flex: 1;
  background: transparent;
  border: none;
  outline: none;
  color: rgba(255, 255, 255, 0.95);
  font-size: 0.9rem;
  font-weight: 500;
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Arial,
    sans-serif;

  &::placeholder {
    color: rgba(255, 255, 255, 0.5);
  }
}

.clear-search-button {
  --color: rgba(255, 255, 255, 0.6);
  --background-hover: rgba(255, 255, 255, 0.1);
  width: 2rem;
  height: 2rem;
  border-radius: 50%;
  margin-left: 0.5rem;
  flex-shrink: 0;

  .clear-icon {
    font-size: 1rem;
  }
}
</style>
